import Hero from '../components/Hero';
import TrustBar from '../components/TrustBar';
import Plans from '../components/Plans';
import Products from '../components/Products';
import Features from '../components/Features';
import PromoCards from '../components/PromoCards';
import Comparison from '../components/Comparison';
import StatsStrip from '../components/StatsStrip';
import Testimonials from '../components/Testimonials';
import Faq from '../components/Faq';
import Insights from '../components/Insights';
import BigCta from '../components/BigCta';
import Newsletter from '../components/Newsletter';

export default function HomePage() {
  return (
    <>
      <Hero />
      <TrustBar />
      <Plans />
      <Features />
      <Products />
      <PromoCards />
      <Comparison />
      <StatsStrip />
      <Testimonials />
      <Faq />
      <Insights />
      <BigCta />
      <Newsletter />
    </>
  );
}
